import { render } from "./TheTeamInfo.vue?vue&type=template&id=603046e1&scoped=true"
import script from "./TheTeamInfo.vue?vue&type=script&lang=js"
export * from "./TheTeamInfo.vue?vue&type=script&lang=js"

import "./TheTeamInfo.vue?vue&type=style&index=0&id=603046e1&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603046e1"]])

export default __exports__